module.exports = __webpack_public_path__ + "themes/mf/img/prize-4@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-4@2x.png
// module id = 93
// module chunks = 3